import { Route, Routes } from "react-router-dom";
import { routes } from './index';
import { Suspense } from "react";
import { URL_CHANNEL, URL_HIDEN_MENU } from "./constants";
import MainChannel from "../components/shared/main-channel";
import Main from "../components/shared/main";

function RouterPage() {
   return (
      <Suspense>
         <Routes>
            {routes.map((route, index) => {
               if (URL_HIDEN_MENU.includes(route.path)) {
                  return (
                     <Route
                        key={index}
                        exact={true}
                        path={route.path}
                        element={route.element}
                     />
                  );
               }
               if (URL_CHANNEL.includes(route.path)) {
                  return (
                     <Route
                        key={index}
                        exact={true}
                        path={route.path}
                        element={<MainChannel>{route.element}</MainChannel>}
                     />
                  );
               }
               return (
                  <Route
                     key={index}
                     exact={true}
                     path={route.path}
                     element={<Main>{route.element}</Main>}
                  />

               );
            })}
         </Routes>

      </Suspense>
   )
}

export default RouterPage;